<mat-card class="workorder-history-card" [ngClass]="className">
  <!-- Header Section -->
  <mat-card-header class="work-history-header header">
    <mat-card-title class="workorder-title">
      Workorder Status History
    </mat-card-title>
    <button mat-icon-button matTooltip="Close" class="close-button" (click)="closedialog()">
      <mat-icon class="close-icon" color="warn">close</mat-icon>
    </button>
  </mat-card-header>

  <!-- Loader -->
  <div class="loader-container" *ngIf="loadWorkorderHistory">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <mat-card-content *ngIf="statusData != undefined && !loadWorkorderHistory" class="table-wrapper">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="statusData.length > 0">

      <!-- Status -->
      <ng-container matColumnDef="STATUS_DESC">
        <th mat-header-cell *matHeaderCellDef>
          <h3>Status</h3>
        </th>
        <td mat-cell *matCellDef="let workorder"
          [ngStyle]="{ color: workorder.TYPE_CD === 'ST' ? 'OrangeRed' : 'DarkGreen' }">
          {{ workorder.STATUS_DESC }}
        </td>
      </ng-container>

      <!-- Date -->
      <ng-container matColumnDef="STATUSDATE">
        <th mat-header-cell *matHeaderCellDef>
          <h3>Date</h3>
        </th>
        <td mat-cell *matCellDef="let workorder"
          [ngStyle]="{ color: workorder.TYPE_CD === 'ST' ? 'OrangeRed' : 'DarkGreen' }">
          {{ workorder.STATUSDATE | date: 'M/dd/yy, h:mm:ss a' }}
        </td>
      </ng-container>

      <!-- System Date -->
      <ng-container matColumnDef="STATUSDATESYS">
        <th mat-header-cell *matHeaderCellDef>
          <h3>System Date</h3>
        </th>
        <td mat-cell *matCellDef="let workorder"
          [ngStyle]="{ color: workorder.TYPE_CD === 'ST' ? 'OrangeRed' : 'DarkGreen' }">
          {{ workorder.STATUSDATESYS | date: 'M/dd/yy, h:mm:ss a' }}
        </td>
      </ng-container>

      <!-- Reason -->
      <ng-container matColumnDef="REASON_DESC">
        <th mat-header-cell *matHeaderCellDef>
          <h3>Reason</h3>
        </th>
        <td mat-cell *matCellDef="let workorder"
          [ngStyle]="{ color: workorder.TYPE_CD === 'ST' ? 'OrangeRed' : 'DarkGreen' }">
          {{ workorder.REASON_DESC }}
        </td>
      </ng-container>

      <!-- User ID -->
      <ng-container matColumnDef="USER_ID">
        <th mat-header-cell *matHeaderCellDef>
          <h3>User Id</h3>
        </th>
        <td mat-cell *matCellDef="let workorder"
          [ngStyle]="{ color: workorder.TYPE_CD === 'ST' ? 'OrangeRed' : 'DarkGreen' }">
          {{ workorder.USER_ID }}
        </td>
      </ng-container>

      <!-- Export Date -->
      <ng-container matColumnDef="EXPORTDATE">
        <th mat-header-cell *matHeaderCellDef>
          <h3>Export Date</h3>
        </th>
        <td mat-cell *matCellDef="let workorder"
          [ngStyle]="{ color: workorder.TYPE_CD === 'ST' ? 'OrangeRed' : 'DarkGreen' }">
          {{ workorder.EXPORTDATE | date: 'M/dd/yy, h:mm:ss a' }}
        </td>
      </ng-container>

      <!-- Table Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="curr-workorder"></tr>

    </table>
  </mat-card-content>

  <!-- Footer Section -->
  <mat-card-footer class="workorder-footer">
    <mat-radio-group class="workorder-history-group" [(ngModel)]="selectedRadioValue"
      (change)="radioStatusChange(selectedRadioValue)">

      <mat-radio-button *ngFor="let option of radioOptions" [value]="option.value" [style.color]="option.color">
        {{ option.label }}
      </mat-radio-button>

    </mat-radio-group>
  </mat-card-footer>

</mat-card>